import { render, staticRenderFns } from "./BaseDetailCard.vue?vue&type=template&id=3285f354&scoped=true&"
import script from "./BaseDetailCard.vue?vue&type=script&lang=js&"
export * from "./BaseDetailCard.vue?vue&type=script&lang=js&"
import style0 from "./BaseDetailCard.vue?vue&type=style&index=0&id=3285f354&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3285f354",
  null
  
)

export default component.exports